import { render, staticRenderFns } from "./reviewOrders.vue?vue&type=template&id=7735bfaa&scoped=true&"
import script from "./reviewOrders.vue?vue&type=script&lang=js&"
export * from "./reviewOrders.vue?vue&type=script&lang=js&"
import style0 from "./reviewOrders.vue?vue&type=style&index=0&id=7735bfaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7735bfaa",
  null
  
)

export default component.exports